import { useRouter } from 'next/router';
import { useSnapshot } from 'valtio/react';

import { Button } from '@paid-ui/components/button';

import { signUpManager } from '../../models';
import { SignUpStep } from '../../models/enums';

interface Props {
  disabled?: boolean;
}

export const StepCreateContract: React.FC<Props> = ({ disabled }) => {
  const router = useRouter();
  const { currentStep } = useSnapshot(signUpManager);

  if (currentStep !== SignUpStep.CREATE_CONTRACT) {
    return null;
  }

  const handleClick = () => {
    router.push('/?dialog=new-project');
  };

  return (
    <div className="space-y-9">
      <Button size="xl" variant="solid" disabled={disabled} onClick={handleClick}>
        Create contract
      </Button>
    </div>
  );
};
